"use client";
import React, { useState } from "react";
import { motion } from "framer-motion";
import CommonImage from "@/components/common/image/CommonImage";
import { FaCirclePlay } from "react-icons/fa6";
import Image from "next/image";
import { useDispatch, useSelector } from "react-redux";
import AuthDrawer from "@/components/common/drawer/AuthDrawer/AuthDrawer";
import { openDrawer } from "@/redux/slices/authDrawerSlice";
import { ToastContainer, toast } from "react-toastify";
import CourseService from "@/services/api/CourseService";
import { Link } from "lucide-react";
import { useRouter } from "next/navigation";
import YoutubePlayer from "@/components/common/Player/YoutubePlayer";
import { Modal } from "antd";
import { MdGroups2 } from "react-icons/md";
export default function CourseHeroSection({ course }) {
  const router = useRouter();
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.user.userInfo);
  const [paymentMethod, setPaymentMethod] = useState("Cash");
  const [paymentFor, setPaymentFor] = useState("Course Enrollment");
  const [amount, setAmount] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);

  console.log("course",course)
  const handleFreeTrial = async () => {
    const payload = {
      course_id: course.id,
    };
    try {
      const response = await CourseService.courseFreeEnroll(payload);
      if (response) {
        toast.success("ফ্রি ট্রায়াল সফলভাবে গ্রহণ করা হয়েছে!");
      }
    } catch (error) {
      const backendMessage = error?.response?.data?.message;
      if (backendMessage) {
        toast.error(backendMessage);
      } else {
        toast.error(
          "⚠️ কোর্সে ইনরোল করতে একটি ত্রুটি ঘটেছে। অনুগ্রহ করে কর্তৃপক্ষের সাথে যোগাযোগ করো।"
        );
      }
    }
  };

  const handleEnroll = async () => {
    try {
      const payload = {
        course_id: course.id,
        payment_method: paymentMethod,
        payment_for: paymentFor,
        amount: amount,
      };
      const response = await CourseService.courseEnroll(payload);
      if (response) {
        toast.success("ইনরোল সফলভাবে গ্রহণ করা হয়েছে!");
      } else {
        toast.error("ইনরোল করতে সমস্যা হয়েছে। আবার চেষ্টা করো।");
      }
    } catch (error) {
      const backendMessage = error?.response?.data?.message;
      if (backendMessage) {
        toast.error(backendMessage);
      } else {
        toast.error(
          "⚠️ কোর্সে ইনরোল করতে একটি ত্রুটি ঘটেছে। অনুগ্রহ করে কর্তৃপক্ষের সাথে যোগাযোগ করো।"
        );
      }
    }
  };


    const handleSelectGroup = (groupId) => {
    setSelectedGroup(groupId);
    setTimeout(() => {
      setIsModalOpen(false);
      router.push(`/course/${course?.slug}/pricing/${groupId}`);
    }, 400);
  };

  return (
    <>
      {" "}
      <ToastContainer />
      <section className="course-details-hero-section">
        <div className="hero-top">
          <div className="content">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
            >
              {/* <h1 className="title"><span className="highlighted">{`SSC '25-এর বোর্ড অনুরূপ`}</span> মডেল টেস্টে A+ প্রস্তুতি ঝালাই করে নাও!</h1> */}
              <h1 className="title">
                <span className="highlighted">{course?.highlight_title}</span>{" "}
                {course?.title}
              </h1>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              {/* {course?.short_description ? (
                <p
                  className="description [.dark_&]:text-d-white"
                  dangerouslySetInnerHTML={{ __html: course.short_description }}
                />
              ) : null} */}

              <p className="description"> {course?.short_description}</p>
            </motion.div>
          </div>
        </div>
        <div className="hero-bottom section_padding">
          <div className="content">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="course-thumbnail"
            >
              {!isPlaying ? (
                <>
                  <CommonImage
                    src={course?.thumbnail_url ?? "/images/home-page/hero.avif"}
                    alt="Hero Image"
                    className="hero-img"
                  />
                  <div className="hero-image-playbtn">
                    <button
                      className="play-btn"
                      onClick={() => setIsPlaying(true)}
                    >
                      <FaCirclePlay className="play-icon" />
                    </button>
                  </div>
                </>
              ) : (
                <Modal
                  open={isPlaying}
                  onCancel={() => setIsPlaying(false)}
                  footer={null}
                  centered
                  width={800}
                  className="video-modal"
                  styles={{
                    body: {
                      padding: 0,
                    },
                  }}
                  destroyOnHidden
                >
                  <div className="aspect-video w-full">
                    <YoutubePlayer url={course?.promo_video} />
                  </div>
                </Modal>
              )}
            </motion.div>

            {/* course price box */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              className="course-price-box fa-card"
            >
              <div className="inner-box ">
                <h3 className="title">
                  <span className="price-icon">
                    <Image
                      src="/images/course-img/price.avif"
                      alt="icon"
                      width={24}
                      height={24}
                    />
                  </span>
                  <span>কোর্স প্রাইস</span>
                </h3>
                <p className="value">
                  ৳{course?.final_payable_amount}/-
                  {course?.discount  > 0 &&
                  <span className="discount-price">
                    {" "}
                    ৳{course?.online_admission_fee}{" "}
                  </span>
}
                </p>
              </div>

              <div className="inner-box">
                <h3 className="title">
                  <span className="price-icon">
                    <Image
                      src="/images/course-img/clock.avif"
                      alt="icon"
                      width={24}
                      height={24}
                      className="price-icon"
                    />
                  </span>
                  <span>কোর্সের সময়সীমা</span>
                </h3>
                <p className="value"> {course?.duration_bangla}</p>
              </div>

              <div className="inner-box !border-b-0">
                <h3 className="title">
                  <span className="price-icon">
                    <Image
                      src="/images/course-img/calendar.avif"
                      alt="icon"
                      width={24}
                      height={24}
                      className="price-icon"
                    />
                  </span>
                  <span>ইনরোলের সময়সীমা</span>
                </h3>
                <p className="value">{course?.duration_date_range_bangla}</p>
              </div>
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.4 }}
                className="course-hero-btns"
              >
                {userInfo ? (
                  <>
                    <button
                      className={`btn-outline w-full ${
                        course.class_model_id !== userInfo?.student?.class_id
                          ? "opacity-50 cursor-not-allowed"
                          : "cursor-pointer"
                      }`}
                      disabled={
                        course.class_model_id !== userInfo?.student?.class_id
                      }
                      onClick={(e) => {
                        if (
                          course.class_model_id !== userInfo?.student?.class_id
                        ) {
                          e.preventDefault();
                          return;
                        }
                        handleFreeTrial();
                      }}
                    >
                      ফ্রি ট্রায়াল দাও
                    </button>
                    <button
                      className="primary-btn w-full cursor-pointer flex items-center justify-center"
                   onClick={() => setIsModalOpen(true)}

                    >
                      ইনরোল করো
                      <CommonImage
                        src="/images/header-footer/arrow-right.avif"
                        alt="Icon"
                        className="btn-icon !h-auto ml-2"
                        width={20}
                      />
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      onClick={() => dispatch(openDrawer("login"))}
                      className="btn-outline w-full cursor-pointer"
                    >
                      ফ্রি ট্রায়াল দাও
                    </button>
                    <button
                      onClick={() => dispatch(openDrawer("login"))}
                      className="primary-btn w-full cursor-pointer"
                    >
                      ইনরোল করো
                      <CommonImage
                        src="/images/header-footer/arrow-right.avif"
                        alt="Icon"
                        className="btn-icon !h-auto"
                        width={20}
                      />
                    </button>
                  </>
                )}
              </motion.div>
            </motion.div>
          </div>
        </div>
        <AuthDrawer />
      </section>
       <Modal
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        centered
        title=""
       className="video-modal"

      >
      <h2 className="text-primary-text-4 font-bold text-xl">তোমার গ্রুপ নির্বাচন করো</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
    {course?.groups?.map((group) => (
      <div
        key={group.id}
        onClick={() => handleSelectGroup(group.id)}
        className={`border border-[#0091ea] rounded-xl p-4 flex items-center justify-center gap-3 text-center cursor-pointer hover:bg-blue-50 [.dark_&]:hover:bg-[#002741] transition-all ${
          selectedGroup === group.id ? "border-[#0091ea] bg-bg-[#002741]" : ""
        }`}
      >
          <div className="w-14 h-14 rounded-full bg-blue-100 [.dark_&]:bg-[#0091ea] flex items-center justify-center mb-2"> 
          <MdGroups2 size={30} className="text-blue-600 [.dark_&]:text-[#fff]"/>
        </div>

        <p className="text-lg font-semibold text-primary-text-4 m-0">{group.name}</p>
      </div>
    ))}
  </div>
      </Modal>
    </>
  );
}
